import * as exchangeRateActions from '../actions/exchangeRate';

const defaultState = {
  latestRate: null,
  historicalRates: null,
  gettingLatestRate: false,
  gettingHistoricalRates: false,
  latestRateError: null,
  historicalRatesError: null,
};

// eslint-disable-next-line default-param-last
const exchangeRate = (state = defaultState, action) => {
  switch (action.type) {
    case exchangeRateActions.GET_LATEST_RATE:
      return {
        ...state,
        gettingLatestRate: true,
        latestRateError: null,
      };
    case exchangeRateActions.GET_LATEST_RATE_SUCCESS:
      return {
        ...state,
        latestRate: action.payload,
        gettingLatestRate: false,
        latestRateError: null,
      };
    case exchangeRateActions.GET_LATEST_RATE_ERROR:
      return {
        ...state,
        gettingLatestRate: false,
        latestRateError: action.payload,
      };
    case exchangeRateActions.GET_HISTORICAL_RATES:
      return {
        ...state,
        gettingHistoricalRates: true,
        historicalRatesError: null,
      };
    case exchangeRateActions.GET_HISTORICAL_RATES_SUCCESS:
      return {
        ...state,
        historicalRates: action.payload,
        gettingHistoricalRates: false,
        historicalRatesError: null,
      };
    case exchangeRateActions.GET_HISTORICAL_RATES_ERROR:
      return {
        ...state,
        gettingHistoricalRates: false,
        historicalRatesError: action.payload,
      };
    default:
      return state;
  }
};

export default exchangeRate;
